import React, { FC, Fragment } from 'react';
import { Typography } from 'enova-frontend-components';
import { Trans } from 'react-i18next';

import { RegistrationActionButtons } from '../../../../screens/registration/components/registrationActionButtons';

interface Props {
  children: React.ReactElement;
}

export const FloorContentWrapper: FC<Props> = ({ children }) => (
  <Fragment>
    <Typography variant="h2" gutterBottom>
      <Trans i18nKey="register.floors.title" />
    </Typography>

    <Typography paragraph>
      <Trans i18nKey={'register.floors.helperText'} />
    </Typography>

    {children}
    <RegistrationActionButtons />
  </Fragment>
);
